// TODO: This will need to be fixed for QA
export const API_URL =
  process.env.NODE_ENV == 'development' ? 'http://localhost:4500' : ''

export const RAILS_ENV = import.meta.env.PUBLIC_RAILS_ENV
export const SENTRY_DSN = import.meta.env.PUBLIC_SENTRY_DSN
